<template>
  <span dir="auto" class="name-book">{{ name }}</span>
</template>

<script>
export default {
  props: ["name"],
};
</script>

<style lang="scss" scoped></style>
